import styled, { css } from "styled-components";
import { Swiper } from 'swiper/react';


export const SwiperWrapper = styled.div`
  position: relative;
  z-index: 0; // Swiper set index 1 automacally
  max-height: 103vh; // to support wider than 16:9 in hero
`

export const SwiperStyled = styled(Swiper)`
  position: relative;
  padding-right: ${({ $offsetLeft }) => `${$offsetLeft}px`};
  padding-left: ${({ $offsetRight }) => `${$offsetRight}px`};
  
  ${({ $isFade }) => $isFade && css`
    .swiper-slide {
      opacity: 0 !important;
      transition: opacity 0s !important;
    }
    
    .swiper-slide-active {
      transition: opacity 1.5s !important;
      opacity: 1 !important;
    }
  `}
`

export const GradientBottom = styled.div`
  position: absolute;
  width: 100%;
  bottom: 0;
  left: 0;
  height: 20%;
  pointer-events: none;
  z-index: 1;
  background: linear-gradient(
    0deg,
    #000000 0%,
    rgba(0, 0, 0, .6) 50%,
    rgba(131, 131, 131, 0) 100%
  );

  ${({ theme }) => theme.old.breakpoints.isTab} {
    height: 30%;
  }

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    height: 0%;
  }
`